import axios from 'axios'
import { BUSCAR_ITINERARIO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarItinerario (codigoEmrpesa, codigo) {
  const url = `${URL}/itinerario/${codigo}/empresa/${codigoEmrpesa}`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_ITINERARIO,
        payload: response

      })
  );
}
